import { render, staticRenderFns } from "./orderDetailChat.vue?vue&type=template&id=7f2045c9&scoped=true"
import script from "./orderDetailChat.vue?vue&type=script&lang=js"
export * from "./orderDetailChat.vue?vue&type=script&lang=js"
import style0 from "./orderDetailChat.vue?vue&type=style&index=0&id=7f2045c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2045c9",
  null
  
)

export default component.exports